import { SET_IS_LOADING } from "./actionTypes";

export const setIsLoadingAction = (isLoading: any) => {
    return {
        type: SET_IS_LOADING,
        payload: isLoading
    };
};
